import {map} from 'lodash';

import Step from '../../../cablingMapEditor/store/Step';
import {BaseActionButton} from './BaseActionButton';

class RemoveLinks extends BaseActionButton {
  icon = 'unlink';
  tooltip = 'Delete links between selected nodes';

  disabled = () => {
    const {selection, selectedLinksGroups} = this.rackEditorStore;
    return selection.nothingSelected || !selectedLinksGroups.length;
  };

  onClick = () => {
    const {rackStore, selectedLinksGroups} = this.rackEditorStore;
    rackStore.changes.register(map(selectedLinksGroups, (linksGroup) => Step.deletion(linksGroup)));
    rackStore.deleteLinksGroups(map(selectedLinksGroups, 'id'));
    this.hidePopups(true, true);
  };
}

export {RemoveLinks};
